import { render } from "./TalronBatteryBarcodeScanditInput.vue?vue&type=template&id=4c36fad4&scoped=true"
import script from "./TalronBatteryBarcodeScanditInput.vue?vue&type=script&lang=js"
export * from "./TalronBatteryBarcodeScanditInput.vue?vue&type=script&lang=js"

import "./TalronBatteryBarcodeScanditInput.vue?vue&type=style&index=0&id=4c36fad4&scoped=true&lang=scss"
import "./TalronBatteryBarcodeScanditInput.vue?vue&type=style&index=1&id=4c36fad4&lang=scss"

import exportComponent from "/srv/sites/eservice.talronbatt.co.il/api/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c36fad4"]])

export default __exports__